import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/Index'
import Home from '@/views/portals/Home'
import News from '@/views/portals/News'
import NewsDetail from '@/views/portals/NewsDetail'
import ArticleDetail from '@/views/ArticleDetail'
import PurchaseNoticeDetail from '@/views/PurchaseNoticeDetail'
import AboutUs from '@/views/portals/AboutUs'
import Organ from '@/views/portals/Organ'
import Service from '@/views/portals/Service'
import Products from '@/views/portals/Products'
import ProductsDetail from '@/views/portals/ProductsDetail'
import Needs from '@/views/portals/Needs'
import NeedsDetail from '@/views/portals/NeedsDetail'
import Login from '@/views/login/login'
import Register from '@/views/portals/register/register'
import signUp from '@/views/signUp'
import ProductInfo from "@/views/ProductInfo";
import workbench from '@/views/workbench'
import work from '@/views/workbench/work.vue'
import trading from '@/views/workbench/trading.vue'
import creditExtension from '@/views/workbench/creditExtension.vue'
import grade from '@/views/workbench/grade.vue'
import score from '@/views/workbench/score.vue'
import basic from '@/views/workbench/basic.vue'
import accredit from '@/views/workbench/accredit.vue'
import security from '@/views/workbench/security.vue'
import financingNeeds from '@/views/workbench/financingNeeds.vue'
import message from '@/views/workbench/message.vue'

Vue.use(Router)

Vue.use(Router)


export default new Router({
  routes: [
    {
      path: '*', // 找不到
      redirect: '/home'
    },
    // 门户
    {
      path: '/',
      name: 'index',
      redirect: '/home',
      component: Index,
      children: [
        {
          path: '/home',
          name: 'home',
          component: Home
        },
        {
          path: '/service',
          name: 'service',
          component: Service,
        },
        {
          path: '/products',
          name: 'products',
          component: Products
        },
        {
          path: '/products/ProductsDetail/:id',
          name: 'productsDetail',
          component: ProductsDetail
        },
        {
          path: '/needs',
          name: 'needs',
          component: Needs
        },
        {
          path: '/needs/NeedsDetail/:id',
          name: 'needsDetail',
          component: NeedsDetail
        },
        {
          path: '/news',
          name: 'news',
          component: News,
        },
        {
          path: '/News/NewsDetail/:id',
          name: 'newsDetail',
          component: NewsDetail
        },

        {
          path: '/:parent/article/:id',
          name: 'article',
          component: ArticleDetail
        },
        {
          path: '/:parent/detail/:id',
          name: 'purchaseNotice',
          component: PurchaseNoticeDetail
        },
        {
          path: '/:parent/productInfo/:id',
          name: 'productInfo',
          component: ProductInfo
        },
        {
          path: '/organ',
          name: 'organ',
          component: Organ,
        },
        {
          path: '/aboutUs',
          name: 'aboutUs',
          component: AboutUs,
        },
        {
          path: '/register',
          name: 'register',
          component: Register
        },
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/signUp',
      name: 'signUp',
      component: signUp
    },

    // 企业端
    {
      path: '/workbench',
      name: 'workbench',
      component: workbench,
      children: [
        {
          path: 'work',
          name: 'work',
          meta: {
            title: '工作台',
          },
          component: work
        },
        {
          path: 'trading',
          name: 'trading',
          meta: {
            title: '融资交易',
          },
          component: trading
        },
        {
          path: 'financingNeeds',
          name: 'financingNeeds',
          meta: {
            title: '我的融资需求',
          },
          component: financingNeeds
        },
        {
          path: 'creditExtension',
          name: 'creditExtension',
          meta: {
            title: '企业确认授信',
          },
          component: creditExtension
        },{
          path: 'grade',
          name: 'grade',
          meta: {
            title: '我的信用评分',
          },
          component: grade
        },{
          path: 'score',
          name: 'score',
          meta: {
            title: '我的信用评分',
          },
          component: score
        },{
          path: 'basic',
          name: 'basic',
          meta: {
            title: '基本信息',
          },
          component: basic
        },{
          path: 'accredit',
          name: 'accredit',
          meta: {
            title: '我的授权',
          },
          component: accredit
        },{
          path: 'security',
          name: 'security',
          meta: {
            title: '账户安全',
          },
          component: security
        },
        {
          path: 'message',
          name: 'message',
          meta: {
            title: '我的消息',
          },
          component: message
        }

      ]
    },

    // 金融机构pc端
    {
      path: "/financInstitutionPC",
      name: "financInstitutionPC",
      component: () => import("@/views/financInstitutionPC/layout/index.vue"),
      redirect: '/financInstitutionPC/staging',
      meta: {
        title: "",
      },
      sort:1,
      children: [
        {
          path: '/financInstitutionPC/staging',
          name: 'staging',
          component: () => import("@/views/financInstitutionPC/staging/index.vue"),
          meta: {
            title: "工作台",
          },
          sort:2
        },
        {
          path: '/financInstitutionPC/message',
          name: 'jrjgMessage',
          component: () => import("@/views/financInstitutionPC/myProduct/message/index.vue"),
          meta: {
            title: "我的消息",
          },
          sort:2
        },
        {
          path: '/financInstitutionPC/myProduct',
          name: 'myProduct',
          component: () => import("@/views/financInstitutionPC/myProduct/index.vue"),
          redirect: '/financInstitutionPC/myProduct/publishProduct',
          meta: {
            title: "我的产品",
          },
          children: [
            {
              path: '/financInstitutionPC/myProduct/publishProduct',
              name: 'publishProduct',
              component: () => import("@/views/financInstitutionPC/myProduct/publishProduct/index.vue"),
              meta: {
                title: "我的金融产品",
              },
              sort:2
            },
            {
              path: '/financInstitutionPC/myProduct/lendingTransactions',
              name: 'lendingTransactions',
              component: () => import("@/views/financInstitutionPC/myProduct/lendingTransactions/index.vue"),
              meta: {
                title: "我的放贷交易",
              },
              sort:2
            }
          ],
          sort:3
        },
        {
          path: '/financInstitutionPC/myCustom',
          name: 'myCustom',
          component: () => import("@/views/financInstitutionPC/myCustom/index.vue"),
          redirect: '/financInstitutionPC/myCustom/creditQuery',
          meta: {
            title: "我的客户",
          },
          children: [
            {
              path: '/financInstitutionPC/myCustom/creditQuery',
              name: 'creditQuery',
              component: () => import("@/views/financInstitutionPC/myCustom/creditQuery/index.vue"),
              meta: {
                title: "企业信用查询",
              },
              sort:2
            },
          ],
          sort:3
        },
        {
          path: '/financInstitutionPC/financInfo',
          name: 'financInfo',
          component: () => import("@/views/financInstitutionPC/financInfo/index.vue"),
          redirect: '/financInstitutionPC/financInfo/baseInfo',
          meta: {
            title: "金融机构信息",
          },
          children: [
            {
              path: '/financInstitutionPC/financInfo/baseInfo',
              name: 'baseInfo',
              component: () => import("@/views/financInstitutionPC/financInfo/baseInfo/index.vue"),
              meta: {
                title: "基本信息",
              },
              sort:2
            },
            {
              path: '/financInstitutionPC/financInfo/certificateAuthority',
              name: 'certificateAuthority',
              component: () => import("@/views/financInstitutionPC/financInfo/certificateAuthority/index.vue"),
              meta: {
                title: "机构认证",
              },
              sort:3
            }
          ],
          sort:3
        },
      ],
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
})
